import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { PartNumber } from "../../../../../shared/models/partNumber.model";
import * as _ from "lodash";
import { AppUtils } from "@app/shared/util/app.utils";

@Component({
    selector: 'app-part-number-form',
    templateUrl: './part-number-form.component.html',
    styleUrls: ['./part-number-form.component.scss']
})
export class PartNumberFormComponent implements OnInit {

    @Input() selectedPartNumbers: PartNumber[];
    @Input() availablePartNumbers: PartNumber[];
    @Input() showValidations = false;

    partNumberForm: UntypedFormGroup;

    constructor() {
    }

    ngOnInit() {
        this.partNumberForm = new UntypedFormGroup({
            selectedPartNumbers: new UntypedFormControl(this.selectedPartNumbers, [AppUtils.notEmptyValidation]),
        });
    }

    isFormValid() {
        return this.partNumberForm.valid;
    }

    reset() {
        this.partNumberForm.reset();
    }

    value() {
        return {partNumberIds: _.map(this.partNumberForm.controls.selectedPartNumbers.value, 'id')};
    }
}
